import { gStore } from '@/lib/keys';
import { useStore } from '@/lib/store';
import { Kbds } from '@/ui/bits';

// The strip at the bottom of the screen after G is pressed, listing where the next key goes.

const TARGETS: [string, string][] = [
  ['T', 'Home'],
  ['I', 'Inbox'],
  ['P', 'People'],
  ['C', 'Companies'],
  ['D', 'Deals'],
  ['F', 'Finder'],
  ['A', 'Activity'],
];

export function GHint() {
  const show = useStore(gStore, (s) => s.hint);
  return (
    <div className={show ? 'g-hint show' : 'g-hint'} id="gHint" aria-hidden="true">
      <Kbds keys="G" />
      <span>then</span>
      {TARGETS.map(([key, label]) => (
        <span className="gk" key={key}>
          <Kbds keys={key} />
          {label}
        </span>
      ))}
    </div>
  );
}
